// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "./components/SidebarPlugin";

// asset imports
import VueMaterial from "vue-material";

import "./assets/scss/styles.scss";
import "vue-material/dist/vue-material.min.css";
import "./assets/scss/material-dashboard.scss";
import VueLayers from "vuelayers";
import "vuelayers/lib/style.css"; // needs css-loader


// library auto imports
import "es6-promise/auto";

/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
export default {
  install(Vue) {
    Vue.use(SideBar);
    Vue.use(VueMaterial);
    Vue.use(VueLayers);
  }
};
